<template>
  <div class="account-options-popup">
    <div class="account-options-popup__top">
      <button class="account-options-popup__close" @click="toggleValue({key: 'isAccountOptionsOpen'})">
        {{ tStatic('closeLink') }} <oie-use-svg svg="close" class="account-options-popup__close-icon"></oie-use-svg>
      </button>
    </div>

    <div class="account-options-popup__actions">
      <a v-if="clientModel.isSuperUser" :href="clientModel.superUserUrl" class="navigational-item navigational-item--arrow navigational-item--white header-account-options">
        {{ tStatic('superUserMenuItem') }}
      </a>
      <a v-if="clientModel.isSuperUser" :href="clientModel.caiAdminUrl" class="navigational-item navigational-item--arrow navigational-item--white header-account-options">
        {{ tStatic('caiMenuItem') }}
      </a>

      <div v-if="clientModel.myPageUrl" class="account-options-popup__section header-account-options">
        <a :href="clientModel.myPageUrl" class="navigational-item navigational-item--arrow navigational-item--white">
          {{ tStatic('myAccountMenuItem') }}
        </a>

        <a
          v-if="clientModel.myMachinesUrl"
          :href="clientModel.myMachinesUrl"
          class="navigational-item navigational-item--white"
          @click.stop="handleExternalMyPagesNavigation(clientModel.myMachinesUrl)">
          {{ tStatic('myMachinesMenuItem') }}
        </a>
      </div>

      <button class="navigational-item navigational-item--white header-account-options" @click="signOut()">
        {{ tStatic('signOutMenuItem') }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { mixinExternal } from '@/mixins/my-pages'

export default {
  mixins: [mixinExternal],
  computed: {
    ...mapGetters(['enableArticleWatch'])
  },
  methods: {
    ...mapActions('ui', ['toggleValue'])
  }
}
</script>

<style lang="scss">
.account-options-popup {
  position: absolute;
  top: 1.5rem;
  right: 0;
  width: 17.8125rem;
  border: 1px solid color(background-blue-3);
  box-shadow: 0 2px 4px 0 rgba(0,0,0,.5);
  z-index: 14;
}

.account-options-popup__top {
  background-color: color(background-blue-6);
  padding: measure(quarter);
  border-bottom: 1px solid color(background-blue-3);
}

.account-options-popup__close {
  @include reset-button;
  margin-left: auto;
}

.account-options-popup__close-icon {
  width: 1.5rem;
  height: 1.5rem;
  margin-left: measure(quarter);
}

.account-options-popup__actions > *.header-account-options {
  border: none;
  border-bottom: 1px solid color(background-blue-3);
  width: 100%;

  &:last-child {
    border-bottom: none;
  }
}

.account-options-popup__actions > .account-options-popup__section {
  background: #fff;
  display: flex;
  flex-direction: column;

  &:hover {
    background-color: #fff;
  }

  .navigational-item {
    border: none;

    &:not(:first-child) {
      min-height: auto;
      padding-left: measure(full);
    }

    &:last-child {
      margin-bottom: measure(quarter);
    }
  }
}

.account-options-popup__actions > *.header-account-options:not(.account-options-popup__section),
.account-options-popup__section > a {
  &:hover {
    background-color: color(background-blue-4);
  }
}
</style>
